<script lang="ts" setup>

const props = defineProps<{
    title: string;
    icon: string;
}>();
</script>


<template>
    <div class="upcoming-step-tile">
        <div class="upcoming-step-tile__icon">
            <app-icon :icon="props.icon" />
        </div>
        <div class="upcoming-step-tile__content">
            <div class="upcoming-step-tile__title">{{ props.title }}</div>
            <slot />
        </div>
    </div>

</template>

<style lang="scss" scoped>
@use 'certifid-v2-client-hub-styles' as *;

.upcoming-step-tile {
    display: flex;
    flex-flow: row nowrap;

    background-color: $gray-lightest;
    padding: 0.75rem;
    border-radius: 0.375rem;

    &__icon {
        display: flex;
        justify-content: center;
        align-items: center;
        flex: 0 0 2.5rem;
        font-size: 2.5rem;
        margin-right: 1.5rem;
    }

    &__content {
        display: flex;
        flex-flow: column nowrap;
        color: $black-high;
        align-items: flex-start;
        font-size: 1rem;
        font-style: normal;
        line-height: 150%;
    }

    &__title {
        font-weight: 700;
        line-height: 150%;
    }

}

</style>